import clsx from 'clsx';
import React from 'react';
import { createStyles } from './styles';

export interface CriteriaNavigationProps {
  currentIndex: number;
  totalQuantity: number;
  className?: string;
}

const CriteriaBullets = ({ currentIndex, totalQuantity, className = '' }: CriteriaNavigationProps): JSX.Element => {
  const classes = createStyles();

  const BulletItems = Array.from({ length: totalQuantity }, (_, index) => (
    <li key={index + 1} className={clsx(classes.bulletItem, index + 1 <= currentIndex && classes.activeBulletItem)} />
  ));

  return (
    <div className={clsx(classes.criteriaNavigation, className)}>
      <h2 className={classes.criteriaTitle}>{`Criteria ${currentIndex} of ${totalQuantity}`}</h2>
      <ul className={classes.bulletList}>{BulletItems}</ul>
    </div>
  );
};

export default CriteriaBullets;
